<div class="date-picker" (click)="stopPropagation($event)">
  <button type="button" class="date-picker-trigger" (click)="toggle($event)">
    {{ displayValue }}
    <span class="date-picker-arrow">⌵</span>
  </button>

  <div class="date-picker-panel" *ngIf="isOpen">
    <div class="date-picker-header">
      <button type="button" class="date-picker-nav" (click)="previous()">‹</button>
      <button type="button" class="date-picker-title" (click)="setFocus(focus === 'day' ? 'month' : 'year', $event)">
        {{ headerLabel }}
      </button>
      <button type="button" class="date-picker-nav" (click)="next()">›</button>
    </div>

    <div class="date-picker-weekdays" *ngIf="focus === 'day'">
      <span *ngFor="let weekDay of weekDayKeys">{{ getWeekDayLabel(weekDay) }}</span>
    </div>

    <div class="date-picker-grid date-picker-days" *ngIf="focus === 'day'">
      <button
        type="button"
        *ngFor="let cell of dayCells"
        [class.selected]="isSelectedDate(cell.value)"
        [class.muted]="!cell.inCurrentMonth"
        (click)="selectDay(cell)">
        {{ cell.label }}
        <span class="selection-dot" *ngIf="isSelectedDate(cell.value)"></span>
      </button>
    </div>

    <div class="date-picker-grid date-picker-months" *ngIf="focus === 'month'">
      <button
        type="button"
        *ngFor="let month of monthKeys; index as i"
        [class.selected]="isSelectedMonth(i)"
        (click)="selectMonth(i)">
        {{ getMonthLabel(month) }}
        <span class="selection-dot" *ngIf="isSelectedMonth(i)"></span>
      </button>
    </div>

    <div class="date-picker-grid date-picker-years" *ngIf="focus === 'year'">
      <button
        type="button"
        *ngFor="let year of yearCells"
        [class.selected]="isSelectedYear(year)"
        (click)="selectYear(year)">
        {{ year }}
        <span class="selection-dot" *ngIf="isSelectedYear(year)"></span>
      </button>
    </div>

    <div class="date-picker-footer">
      <button type="button" [class.active]="focus === 'day'" (click)="setFocus('day', $event)">{{ 'DATE_PICKER.DAY' | translate }}</button>
      <span>/</span>
      <button type="button" [class.active]="focus === 'month'" (click)="setFocus('month', $event)">{{ 'DATE_PICKER.MONTH' | translate }}</button>
      <span>/</span>
      <button type="button" [class.active]="focus === 'year'" (click)="setFocus('year', $event)">{{ 'DATE_PICKER.YEAR' | translate }}</button>
      <button type="button" class="confirm-button" (click)="confirm()">{{ 'BUTTONS.CONFIRM' | translate }}</button>
    </div>
  </div>
</div>
